import React from 'react';
import { banner } from './Banner.module.css';
import { imgUrlGenerate } from '../../../helpers';
import { FOR_YOUR_PLEASURE, COFFEE, CONTACT_US, THANK_YOU } from '../../../utils/constants';
import { string, node } from 'prop-types';

const Banner = ({ pageType, title, children }) => (
  <div className={banner} style={
    {
      background:
        `#808080ba url(${
        pageType === FOR_YOUR_PLEASURE ? imgUrlGenerate(`coverlid.jpg`) :
          pageType === COFFEE ? imgUrlGenerate(`Coffee_bg.jpg`) :
            pageType === (CONTACT_US || THANK_YOU) ? imgUrlGenerate(`contact-us-bg.jpg`) :
              imgUrlGenerate(`coverlid.jpg`)
        }) center no-repeat`
    }
  }>
    {children}
    <h1 className="title-big">{`${title}`}</h1>
  </div>
)

Banner.propTypes = {
  pageType: string,
  title: string,
  children: node,
}

Banner.defaultProps = {
  pageType: '',
  title: '',
  children: null,
}

export default Banner